import React from "react";
import { TrendingDown } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { SectionToggle, NumInput } from "./shared";

export default function GlidePathSection({ inputs, setInputs, open, onToggle }) {
  const gpOn = inputs.glide_path?.enabled;
  const updateGP = (k, v) => setInputs({ ...inputs, glide_path: { ...inputs.glide_path, [k]: v } });
  const toggleGP = (v) => {
    if (v && !inputs.glide_path) {
      setInputs({
        ...inputs,
        glide_path: { enabled: true, end_stocks_pct: 30, end_age: Math.max(inputs.retirement_age + 15, 80) },
      });
    } else if (v) {
      updateGP("enabled", true);
    } else {
      updateGP("enabled", false);
    }
  };

  return (
    <div>
      <SectionToggle
        testId="toggle-glidepath"
        icon={TrendingDown}
        title="Glide-path allocation"
        subtitle="Auto-shift toward bonds as you age"
        badge={gpOn ? "on" : "off"}
        open={open}
        onToggle={onToggle}
      />
      {open && (
        <div className="pb-5 space-y-4">
          <div className="flex items-center justify-between text-sm">
            <Label className="text-[#1C2B23]">Enable glide path</Label>
            <Switch data-testid="gp-enabled" checked={!!gpOn} onCheckedChange={toggleGP} />
          </div>
          {gpOn && (
            <>
              <div className="grid grid-cols-2 gap-3">
                <NumInput id="gp-end-stocks" testid="gp-end-stocks" label="End stocks %" value={inputs.glide_path.end_stocks_pct} onChange={(v) => updateGP("end_stocks_pct", v)} suffix="%" step={1} />
                <NumInput id="gp-end-age" testid="gp-end-age" label="Reach by age" value={inputs.glide_path.end_age} onChange={(v) => updateGP("end_age", v)} suffix="yrs" />
              </div>
              <p className="text-[11px] text-[#5C6B62] leading-relaxed">
                Linearly de-risks your portfolio from the current stocks % down to the end target.
                Bonds + cash split the remainder proportionally to your current ratio.
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
